import { PrimaryButton } from '@client/new/components/button';
import { LandingMediaDropbox } from './MediaDropBox';
import { faImage } from '@fortawesome/pro-regular-svg-icons';
import { useFormContext, Controller, useFieldArray } from 'react-hook-form';
import { get } from 'lodash';
import { FieldDesc } from './common';
import { F1 } from '../../helpers/types';

const LANDING_PAGE_URL = import.meta.env.VITE_LANDING_PAGE_URL;

export const DEFAULT_LOGOS = [1, 2, 3, 4, 5, 6].map((i) => {
  return { url: `/images/landing/logos/${i}.png` };
});

type Props = {
  imageUpload: (file: File) => Promise<string>;
  index: number;
};
export function LogosForm({ imageUpload, index }: Props) {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: `sections.${index}.logos`,
  });

  const handleOnChange =
    <T,>(onChange: F1<T>, i: number) =>
    (value: T) => {
      if (!value) remove(i);
      else onChange(value);
    };

  const erroMessage = get(errors, `sections.${index}.logos`);
  const errorMessageString =
    typeof erroMessage?.message === 'string' ? erroMessage.message : '';

  return (
    <div>
      <FieldDesc>Minimum 3 logos required to use this section</FieldDesc>
      <div className="flex flex-wrap gap-5 items-center">
        {fields.map((field, i) => (
          <Controller
            key={field.id}
            name={`sections.${index}.logos.${i}.url`}
            control={control}
            render={({
              field: { value, onChange, ref },
              fieldState: { error },
            }) => (
              <LandingMediaDropbox
                optional
                upload={imageUpload}
                inputRef={ref}
                label=""
                validationText={''}
                value={
                  value?.startsWith('/images')
                    ? LANDING_PAGE_URL + value
                    : value
                }
                onChange={handleOnChange(onChange, i)}
                type="image"
                icon={faImage}
                errorMsg={error?.message}
                short
                height="50px"
                width="150px"
              />
            )}
          />
        ))}
        {fields.length < 6 ? (
          <PrimaryButton
            className="h-[50px] relative top-1 w-[150px]"
            type="button"
            onClick={() => append({ url: '' })}
          >
            Add Logo
          </PrimaryButton>
        ) : null}
      </div>

      {errorMessageString ? (
        <div className="mt-4 text-red-500">{errorMessageString}</div>
      ) : null}
    </div>
  );
}
